import * as types from '../../../../types/masters/metalPurity/purityConfiguration/purityConfigurationTypes';
import * as api from '../../../../../api/masters/metalPurity/purityConfiguration/purityConfigurationApi';

export const fetchPurityConfigurations = () => async (dispatch) => {
  dispatch({ type: types.FETCH_PURITY_CONFIGURATION_REQUEST });
  try {
    const data = await api.fetchPurityConfigurations();
    dispatch({ type: types.FETCH_PURITY_CONFIGURATION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_PURITY_CONFIGURATION_FAILURE, payload: error.message });
  }
};

export const addPurityConfiguration = (purityConfiguration) => async (dispatch) => {
  try {
    const res = await api.addPurityConfiguration(purityConfiguration);
    dispatch({ type: types.ADD_PURITY_CONFIGURATION_SUCCESS, payload: res });
    dispatch(fetchPurityConfigurations());
  } catch (error) {
    dispatch({ type: types.PURITY_CONFIGURATION_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updatePurityConfiguration = (id, purityConfiguration) => async (dispatch) => {
  try {
    console.log('Updating purity configuration with ID:', id, 'Data:', purityConfiguration);
    const res = await api.updatePurityConfiguration(id, purityConfiguration);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_PURITY_CONFIGURATION_SUCCESS, payload: res });
    dispatch(fetchPurityConfigurations());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.PURITY_CONFIGURATION_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deletePurityConfiguration = (id) => async (dispatch) => {
  try {
    await api.deletePurityConfiguration(id);
    dispatch({ type: types.DELETE_PURITY_CONFIGURATION_SUCCESS, payload: id });
    dispatch(fetchPurityConfigurations());
  } catch (error) {
    dispatch({ type: types.PURITY_CONFIGURATION_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setPurityConfigurationEdit = (purityConfiguration) => ({
  type: types.SET_PURITY_CONFIGURATION_EDIT,
  payload: purityConfiguration,
});

export const clearPurityConfigurationEdit = () => ({
  type: types.CLEAR_PURITY_CONFIGURATION_EDIT,
}); 